module.exports = __webpack_public_path__ + "media/fr_fr_s2_Dennise.abba3a9d.mp3";